module.exports = __webpack_public_path__ + "img/folder.c9da3d4e.svg";